import * as React from "react"
import { createPage } from "blog/page"
import { createNavigation } from "blog/components/navigation"
import { JSONRenderer } from "blog/components/json_renderer"

const page = createPage(createNavigation(), "About")

export const About = () => <JSONRenderer json={page} />
